/* unplugin-vue-components disabled */import { render } from "./SearchUser.vue?vue&type=template&id=7811f0b0&ts=true"
import script from "./SearchUser.vue?vue&type=script&lang=ts"
export * from "./SearchUser.vue?vue&type=script&lang=ts"

import "./SearchUser.vue?vue&type=style&index=0&id=7811f0b0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__